<template>
  <main>
    <filter-list></filter-list>
    <creator-list></creator-list>
    <hr>
    <div class="desktop-2up">
      <MissionStatement />
      <ContactUs />
    </div>
    <div class="desktop-2up">
      <SupportUs />
    </div>
  </main>
</template>

<script>
import CreatorList from './CreatorList.vue';
import FilterList from './FilterList.vue';
import MissionStatement from './MissionStatement.vue';
import ContactUs from './ContactUs.vue';
import SupportUs from './SupportUs.vue';

export default {
  components: {
    CreatorList,
    FilterList,
    MissionStatement,
    ContactUs,
    SupportUs
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?67cfc121